import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bc-prompt-glow-layer",
  "aria-hidden": "true"
}


export default {
  __name: 'GlowFrame',
  props: {
  focused: { type: Boolean, default: false },
  subtle: { type: Boolean, default: false },
  interactive: { type: Boolean, default: false },
  show: { type: Boolean, default: true },
  frameClass: { type: String, default: '' }
},
  setup(__props) {

if (typeof CSS !== 'undefined' && CSS.registerProperty) {
  try {
    CSS.registerProperty({ name: '--bcang', syntax: '<angle>', inherits: false, initialValue: '0deg' })
  } catch (e) {
    void e
  }
}


return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bc-prompt relative", [
      __props.frameClass || 'rounded-catering-xl',
      { 'bc-prompt-focus': __props.focused, 'bc-prompt-subtle': __props.subtle, 'bc-prompt-interactive': __props.interactive }
    ]])
  }, [
    (__props.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "bc-prompt-glow bc-prompt-glow-soft" }, null, -1),
          _createElementVNode("div", { class: "bc-prompt-glow bc-prompt-glow-sharp" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

}